import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from 'axios';
import Form from "../components/Form";
import '../styles/Signature.css'

const Signature = () => {
    const navigate = useNavigate();
    const {token} = useParams();
    const [customer, setCustomer] = useState({});
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(!loading);
        const getClient = async () => {
            try {
                const url = `${process.env.REACT_APP_SERVIMAX_API_URL}/cliente/VerificarTokenFirma?token=${token}`;
                const response = await axios.get(url);
                if (!response.data.state) {
                    navigate('/')
                    return;
                }
                response.data.data.token = token;
                setCustomer(response.data.data);
            } catch (error) {
                navigate('/')
                return;
            }
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
        getClient();
    }, []);
    return (
        <div className="d-flex justify-content-center align-items-center">
            <Form customer={customer}
                  setLoading={setLoading}
                  loading={loading}/>
        </div>
    )
}
export default Signature;